module.exports = __webpack_public_path__ + "static/dig-4cce92a64d317693cf0fc06b49b701ee.jpg";